import React from 'react';
import PropTypes from 'prop-types';

const thTdStyle = {
    border: '1px solid #ccc',
    padding: '4px',
    textAlign: 'center',
    fontSize: '14px',
};


const tdTdStyle = {
    border: '1px solid #ccc',
    padding: '4px',
    textAlign: 'left',
    fontSize: '14px',
};

const MahadasaTable = ({ dasaRecords }) => (
    <div>
        <div style={{ textAlign: 'left', margin: '4px 0', fontWeight: 'bold', fontSize: '0.8em' }}>
            මහ දසා
        </div>
        <table style={{ borderCollapse: 'collapse', width: '100%', paddingTop: '60px', fontSize: '16px', background: '#fff' }}>
            <thead>
                <tr>
                    <th style={thTdStyle}>දසාව</th>
                    <th style={thTdStyle}>සිට</th>
                    <th style={thTdStyle}>දක්වා</th>
                    <th style={thTdStyle}>කාල පරාසය</th>
                </tr>
            </thead>
            <tbody>
                {dasaRecords.map((record, idx) => (
                    <tr key={idx}>
                        <td style={tdTdStyle}>{record.dasaL1}</td>
                        <td style={tdTdStyle}>{record.from}</td>
                        <td style={tdTdStyle}>{record.to}</td>
                        <td style={tdTdStyle}>{record.duration}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
);

MahadasaTable.propTypes = {
    dasaRecords: PropTypes.arrayOf(
        PropTypes.shape({
            dasaL1: PropTypes.string.isRequired,
            from: PropTypes.string.isRequired,
            to: PropTypes.string.isRequired,
            duration: PropTypes.string.isRequired,
        })
    )
};

export default MahadasaTable;